module.exports = __webpack_public_path__ + "static/media/oil_painting_2.e56c6ad2.png";